import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PortalFiltersSheetProvider } from "@/contexts/portal-filters-sheet";
import { PortalFiltersSheet } from "@/components/portal/PortalFiltersSheet";

// NOTE: no head() here — canonical lives on leaf routes (portal.index.tsx and
// portal.$.tsx) to avoid duplicate <link rel="canonical"> tags.
export const Route = createFileRoute("/portal")({
  component: () => (
    <PortalFiltersSheetProvider>
      <Outlet />
      <PortalFiltersSheet />
    </PortalFiltersSheetProvider>
  ),
});
